import * as yup from 'yup'

export class VehicleCheckInClusterWithOdometerPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInClusterWithOdometerPhotoFile?: File = undefined
}

export const vehicleCheckInClusterWithOdometerPhotoValidationSchema = yup.object({
  vehicleCheckInClusterWithOdometerPhotoFile: yup.mixed().notRequired()
})
